module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Sushi-d5789cac7590028e5220f211c0ffbe70.svg";